import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { antiSpamApi } from "../http/Api";

export const getAntiSpam = createAsyncThunk(
  "AntiSpam/getAntiSpam",
  async (_, thunkAPI) => {
    const {serverId} = thunkAPI.getState().serverId;
    const response = await antiSpamApi.getAntiSpam(serverId);
    console.log("response", response);

    if (response.status === 200) {
      thunkAPI.dispatch(antiSpamSlice.actions.setAntiSpam(response));
    }
  }
);


export const getAntiSpamAdvanced = createAsyncThunk(
  "AntiSpam/getAntiSpamAdvanced",
  async (_, thunkAPI) => {
    const {serverId} = thunkAPI.getState().serverId;
    const response = await antiSpamApi.getAntiSpamAdvanced(serverId);
    console.log("response", response);

    if (response.status === 200) {
      thunkAPI.dispatch(antiSpamSlice.actions.setAntiSpamAdvanced(response));
    }
  }
);

export const getAntiSpamLogs = createAsyncThunk(
  "AntiSpam/getAntiSpamLogs",
  async (_, thunkAPI) => {
    const {serverId} = thunkAPI.getState().serverId;
    const response = await antiSpamApi.getLogs(serverId);
    console.log("response", response);

    if (response.status === 200) {
      thunkAPI.dispatch(antiSpamSlice.actions.setAntiSpamLogs(response));
    }
  }
);

const initialState = {
  antiSpamGlobalState: null,
  antiSpamAdvancedGlobalState: null,
  antiSpamLogsState: null,
};

const antiSpamSlice = createSlice({
  name: "antiSpam",
  initialState,
  reducers: {
    setAntiSpam: (state, action) => {
      state.antiSpamGlobalState = action.payload;
    },
    setAntiSpamAdvanced: (state, action) => {
      state.antiSpamAdvancedGlobalState = action.payload;
    },
    setAntiSpamLogs: (state, action) => {
      state.antiSpamLogsState = action.payload;
    },
  },
});


export const antiSpam = antiSpamSlice.reducer;
